import { phone } from '~utils/format';

angular.module('wbFilters').filter('phone', () => phone);
